import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface TenantPortfolioFilter {
  startDate?: string;
  endDate?: string;
  product?: number[];
  status?: number[];
  plan?: number[];
}

export interface SubscriptionReportFilter {
  startDate?: string;
  endDate?: string;
  product?: number[];
  subscriptionState?: string[];
  plan?: number[];
}

const buildQuery = (params: Record<string, unknown>) => {
  const query: Record<string, string> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length) query[key] = value.join(',');
    } else if (value !== undefined && value !== '') {
      query[key] = String(value);
    }
  });
  const qs = new URLSearchParams(query).toString();
  return qs ? `?${qs}` : '';
};

const previewTenantPortfolio = (filter: TenantPortfolioFilter) =>
  http.get(`${API_ENDPOINTS.reportsTenantsPreview}${buildQuery(filter as Record<string, unknown>)}`);

const exportTenantPortfolio = (filter: TenantPortfolioFilter) =>
  http.get(`${API_ENDPOINTS.reportsTenantsExport}${buildQuery(filter as Record<string, unknown>)}`, { responseType: 'blob' });

const previewSubscriptions = (filter: SubscriptionReportFilter) =>
  http.get(`${API_ENDPOINTS.reportsSubscriptionsPreview}${buildQuery(filter as Record<string, unknown>)}`);

const exportSubscriptions = (filter: SubscriptionReportFilter) =>
  http.get(`${API_ENDPOINTS.reportsSubscriptionsExport}${buildQuery(filter as Record<string, unknown>)}`, { responseType: 'blob' });

const ReportsService = {
  previewTenantPortfolio,
  exportTenantPortfolio,
  previewSubscriptions,
  exportSubscriptions,
};

export default ReportsService;
